import { toast } from "react-toastify";

const handleFBMessenger = async (bot_id, user_id, setProcess) => {
  const fbLoginCallback = (response, bot_id, user_id) => {
    console.log(response);
    if (response.authResponse) {
      (async () => {
        const code = response.authResponse.code;
        if (code) {
          // const uri = "http://localhost:8000/int/handleFbMsgFlow";
          const uri = `${process.env.REACT_APP_SERVER}/int/handleFbMsgFlow`;
          const option = {
            method: "PUT",
            headers: {
              "Content-Type": "application/json", // <-- REQUIRED
            },
            body: JSON.stringify({ code, bot_id, user_id }),
          };

          const res = await fetch(uri, option);

          if (res.ok) {
            toast.success("Facebook Messenge Connected Successfully");
            setTimeout(() => setProcess((prev) => !prev), 2000);
          } else {
            toast.error("Internal server error, try agin later...");
          }
        } else {
          toast.error("FB login canceled or failed, try again later");
          console.warn("FB login canceled or failed", response);
        }
      })();
    } else {
      console.warn("FB login canceled or failed", response);
      toast.error("FB login canceled or failed");
    }
  };

  if (!window.FB) {
    console.error("Facebook SDK not loaded");
    return;
  }

  try {
    window.FB.login((response) => fbLoginCallback(response, bot_id, user_id), {
      config_id: "24514543308145933",
      response_type: "code",
      override_default_response_type: true,
      return_scopes: true,
      enable_profile_selector: true,
      extras: {
        setup: {},
        featureType: "",
        sessionInfoVersion: "2",
      },
    });
  } catch (err) {
    console.error("FB login error:", err);
    toast.error("FB login canceled or failed");
  }
};

export default handleFBMessenger;
